import React from 'react';
import { timeStamp } from '../utils/helper';

function TimeStamp({ src, type, message }) {
  return (
    <span className="rcw-timestamp">
      { message?.from === "flow" ? `Bot • ` : message?.from === "agent" ? `Agent • ` : '' } {message?.timeStamp
        ? timeStamp(message?.timeStamp)
        : timeStamp(message?.timestamp)}
    </span>
  );
}

export default TimeStamp;
